export default {
  title: 'Thanks!',
  subtitle:
    'We now need your phone number so we can discuss any offer you may receive.',
  paragraph: 'What’s the best number to reach you on?',
  phoneNumberLabel: 'Phone number',
  submitButton: 'Continue'
};
